var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2rem",
    height: "2rem",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M26.89 3.638c.54-1.616-1.058-3.123-2.639-2.49l-.493.196L2.055 8.092c-1.28.398-1.435 2.144-.247 2.762l10.005 5.2c.032.017.065.033.098.047.014.033.03.065.046.097l5.206 9.995c.618 1.188 2.366 1.032 2.764-.246l6.73-21.612.234-.697ZM4.274 9.496a.2.2 0 0 0-.033.369l8.041 4.18a.2.2 0 0 0 .234-.037l9.706-9.697c.147-.148-.002-.394-.201-.332L4.273 9.496Zm14.248 14.235a.2.2 0 0 1-.368.033L13.97 15.73a.2.2 0 0 1 .037-.234L23.712 5.8c.147-.148.394.001.332.2l-5.523 17.732Z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.e9473f89293ac0dcf4272fdd6ed760ab.svg";
export { ForwardRef as ReactComponent };